import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

function InfoSection({
  icon,
  title,
  description,
  align = "center",
  textAlign = "left",
}) {
  const theme = useTheme();

  return (
    <Box sx={{ textAlign: align }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          justifyContent: align === "center" ? "center" : "flex-start",
          mb: 1,
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.primary.subtitle,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "99px",
            padding: "4px 16px",
            width: "auto",
            height: "35px",
            mb: "10px",
          }}
        >
          <Box
            component="img"
            src={icon}
            alt="icon"
            sx={{
              width: 16,
              height: 16,
            }}
          />
          <Typography
            sx={{
              color: theme.palette.primary.label,
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
      <Typography
        sx={{
          color: theme.palette.primary.title,
          fontWeight: "700",
          textAlign: textAlign,
          fontSize: {
            xs: "24px",
            sm: "30px",
            md: "36px",
            lg: "40px",
          },
          lineHeight: {
            xs: "32px",
            sm: "36px",
            md: "44px",
            lg: "48px",
          },
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}

export default InfoSection;
